module.exports = __webpack_public_path__ + "img/MatrikelFront.7391cd4a.png";